import '.jj{display:inline-block;}.ssr-plugin'
import '.i7{margin-top:1.5rem;}.ssr-plugin'
import '.ay{font-size:0.875rem;}.ssr-plugin'
import '.jk{color:var(--palette-blue-500);}.ssr-plugin'
import '.im{text-decoration:underline;}.ssr-plugin'
import { useEffect, useState } from 'react'
import { styled } from 'inlines'

export type DiscoveryCrawlerPaginationFooterProps = {
  nextPageHref: string | null
}

export const DiscoveryCrawlerPaginationFooter = ({
  nextPageHref,
}: DiscoveryCrawlerPaginationFooterProps) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!nextPageHref || mounted) {
    return null
  }

  return (
    <a className="jj i7 ay jk im"
      rel="next"
      href={nextPageHref}
    >
      next page
    </a>
  )
}
